// Internationalization string tables with locale variants (es, es-MX, en, en-US)
// Base Spanish and English objects; regional variants alias the base.

const ES_BASE = {
  property: {
    visit: {
      virtualCta: 'Quiero agendar mi visita virtual',
      virtualTitle: 'Visita virtual',
      virtualBody: 'Por el momento, las visitas virtuales se coordinan directamente con un asesor. No hay horarios disponibles para agendar desde el sitio.',
      virtualNoSlots: 'Para visitas virtuales no mostramos horarios. Contáctanos para coordinar por videollamada.'
    }
  },
  form: {
    tabs: {
      basic: 'Básico',
      location: 'Ubicación',
      media: 'Multimedia',
      features: 'Características',
      video: 'Video/Planos',
      owner: 'Propietario',
      review: 'Revisar'
    },
    buttons: {
      previous: 'Anterior',
      next: 'Siguiente',
      saving: 'Guardando...',
      publish: 'Publicar Propiedad',
      update: 'Actualizar Propiedad'
    },
    labels: {
      title: 'Título',
      address: 'Dirección',
      operationType: 'Tipo de operación',
      price: 'Precio',
      select: 'Selecciona',
      sale: 'Venta',
      rent: 'Renta'
    },
    toasts: {
      successCreateTitle: 'Éxito',
      successCreateDesc: 'Propiedad creada.',
      successUpdateTitle: 'Actualizado',
      successUpdateDesc: 'Propiedad actualizada.',
      missingImagesTitle: 'Faltan imágenes',
      missingImagesDesc: 'Debes agregar al menos una imagen.',
      uploadErrorTitle: 'Error',
      uploadErrorDesc: 'No se pudieron subir las imágenes.'
    },
    ownerTab: {
      title: 'Selecciona al propietario',
      subtitle: 'Vincula esta propiedad con una solicitud existente para mantener el seguimiento.',
      searchPlaceholder: 'Buscar por nombre, email o WhatsApp',
      filters: {
        all: 'Todos',
        rented: 'Sí le rentamos',
        not_rented: 'No le rentamos',
        completed: 'Adquisición'
      },
      statusDisplay: {
        completed: 'Adquisición',
        rented: 'Sí le rentamos',
        not_rented: 'No le rentamos'
      },
      selectedOwnerTitle: 'Propietario seleccionado',
      selectedOwnerEmpty: 'Aún no has seleccionado a nadie.',
      clearSelection: 'Quitar propietario',
      emptyTitle: 'Sin coincidencias',
      emptyDescription: 'No encontramos propietarios con esos filtros. Ajusta la búsqueda o revisa el panel de solicitudes.',
      selectCta: 'Seleccionar',
      changeCta: 'Cambiar propietario',
      loading: 'Cargando propietarios...',
      error: 'No se pudo cargar la lista de propietarios.',
      retry: 'Reintentar',
      contact: {
        whatsapp: 'WhatsApp',
        email: 'Email'
      },
      profileTitle: 'Propietario',
      selectorTitle: 'Propietarios',
      selectorSubtitle: 'Filtra y elige al propietario correcto para vincular esta propiedad.',
      statusLabel: 'Estado',
      updatedAt: 'Actualizado {{relative}}',
      readyBadge: 'Listo para publicar'
    }
  },
  edit: {
    title: 'Editar Propiedad',
    loading: 'Cargando propiedad...',
    errors: {
      titleAddressRequired: 'El título y la dirección son requeridos',
      mustUploadImage: 'Debes subir al menos una imagen',
      updateFailed: 'Error al actualizar la propiedad'
    },
    toasts: {
      successUpdateTitle: 'Éxito',
      successUpdateDesc: 'Propiedad actualizada correctamente'
    },
    nav: {
      applyChanges: 'Aplicar cambios',
      savingChanges: 'Guardando cambios...'
    }
  },
  errors: {
    required: 'Requerido',
    numeric: 'Numérico',
    fetchSuggestions: 'No se pudieron cargar sugerencias',
    reverseGeocode: 'No se pudo obtener dirección',
  missingImages: 'Debes agregar al menos una imagen.',
  validationFailed: 'Validación fallida',
  uploadFailed: 'La subida falló',
  unexpected: 'Ocurrió un error inesperado'
  },
  location: {
    searchLabel: 'Dirección / Búsqueda',
    searchPlaceholder: 'Ingresa dirección, colonia, ciudad...',
    searching: 'Buscando...',
    mapLoading: 'Cargando mapa (requiere Google Maps)...',
    reverseFetching: 'Obteniendo dirección...',
    geocodeNote: 'La geocodificación se ejecuta tras pausa de escritura',
    reverseButton: 'Reverse',
    title: 'Ubicación de la Propiedad',
    fullAddress: 'Dirección completa',
    city: 'Ciudad',
    state: 'Estado',
    zip: 'Código Postal',
    coordinates: 'Coordenadas',
    mapPreview: 'Vista previa del mapa',
    addressHint: 'Escribe y selecciona una sugerencia para guardar automáticamente coordenadas.',
    enterAddressMap: 'Ingresa una dirección para verla en el mapa',
    loadingMapNoGoogle: 'Cargando mapa (Google Maps no disponible)...'
  },
  media: {
    title: 'Multimedia',
    dragHere: 'Arrastra imágenes aquí o',
    select: 'Seleccionar',
    upload: 'Subir',
    progress: 'Progreso',
    none: 'Sin imágenes agregadas',
    uploading: 'Subiendo',
    error: 'Error',
    featured: 'Destacada',
    drag: 'Arrastra',
    retry: 'Reintentar',
    retrying: 'Reintentando...',
    failedCount: 'fallida(s)',
    cancelUpload: 'Cancelar subida',
    confirmCancelTitle: 'Cancelar subida',
    confirmCancelDesc: 'Hay subidas en progreso. ¿Deseas cancelarlas?',
    confirm: 'Confirmar',
  dismiss: 'Cerrar',
  propertyMediaTitle: 'Multimedia de la Propiedad',
  propertyImagesLabel: 'Imágenes de la propiedad',
  advancedOptimization: 'Optimización avanzada (WebP)',
  threads: 'Hilos',
  quality: 'Calidad',
  averageSavings: 'Ahorro promedio',
  dropImagesHere: 'Arrastra y suelta imágenes aquí',
  clickToSelect: 'o haz clic para seleccionar',
  selectImages: 'Seleccionar imágenes',
  setAsFeatured: 'Establecer como principal',
  primary: 'Principal',
  image: 'Imagen',
  imagesListLabel: 'Imágenes de la propiedad (reordenables)',
  keyboardInstructions: 'Para reordenar: presiona Espacio para seleccionar una imagen, usa las flechas para moverla y Espacio nuevamente para soltar.',
  imageAlt: 'Imagen {{index}}',
  remove: 'Eliminar imagen',
  markFeatured: 'Marcar como destacada',
  retryOne: 'Reintentar subida',
  replace: 'Reemplazar',
  removeImage: 'Eliminar imagen',
  dragToReorder: 'Arrastra para reordenar'
  },
  video: {
    sectionTitle: 'Video, Planos y Enlaces',
    videoUrlLabel: 'URL de video (YouTube)',
    videoUrlPlaceholder: 'Ej: https://www.youtube.com/watch?v=dQw4w9WgXcQ',
    virtualTour: 'Tour virtual (URL)',
    externalLink: 'Enlace externo',
    plans: 'Planos / PDFs',
    add: 'Agregar',
    newCount: 'nuevo(s)',
    noPlans: 'Sin planos agregados.',
    preview: 'Vista previa',
    video: 'Video',
    tour: 'Tour virtual',
    link: 'Enlace externo',
    plansShort: 'Planos',
    validating: 'Validando',
    valid: 'Válido',
    invalidUrlTitle: 'URL no válida',
    invalidUrlDesc: 'La URL de YouTube no es válida. Verifica el formato.',
    warningInvalidInline: 'La URL parece no ser válida. Verifica el formato.',
    thumbnailLabel: 'Imagen destacada del video',
    selectImage: 'Seleccionar imagen',
    thumbnailHelp: 'Puedes elegir una imagen personalizada para la miniatura (recomendado 1280x720px)',
    exampleValid: 'Ejemplo de formato válido',
    openOnYoutube: 'Ver en YouTube',
  clear: 'Limpiar',
  plansDropzoneLabel: 'Zona para soltar planos'
  },
  review: {
    title: { prefix: 'Revisar y Publicar' },
    basicInfo: 'Información Básica',
    location: 'Ubicación',
    media: 'Multimedia',
    featuredImage: 'Imagen destacada',
    mainImage: 'Imagen principal',
    noExtraImages: 'No hay imágenes adicionales',
    extraFeatures: 'Características adicionales'
  }
};

const EN_BASE = {
  property: {
    visit: {
      virtualCta: 'I want to schedule my virtual visit',
      virtualTitle: 'Virtual visit',
      virtualBody: 'For now, virtual visits are coordinated directly with an agent. Scheduling from the site is not available.',
      virtualNoSlots: 'We do not show time slots for virtual visits. Contact us to coordinate a video call.'
    }
  },
  form: {
    tabs: {
      basic: 'Basic',
      location: 'Location',
      media: 'Media',
      features: 'Features',
      video: 'Video/Plans',
      owner: 'Owner',
      review: 'Review'
    },
    buttons: {
      previous: 'Previous',
      next: 'Next',
      saving: 'Saving...',
      publish: 'Publish Property',
      update: 'Update Property'
    },
    labels: {
      title: 'Title',
      address: 'Address',
      operationType: 'Operation type',
      price: 'Price',
      select: 'Select',
      sale: 'Sale',
      rent: 'Rent'
    },
    toasts: {
      successCreateTitle: 'Success',
      successCreateDesc: 'Property created.',
      successUpdateTitle: 'Updated',
      successUpdateDesc: 'Property updated.',
      missingImagesTitle: 'Missing images',
      missingImagesDesc: 'You must add at least one image.',
      uploadErrorTitle: 'Error',
      uploadErrorDesc: 'Images could not be uploaded.'
    },
    ownerTab: {
      title: 'Select the owner',
      subtitle: 'Link this property to an existing owner request to keep your pipeline in sync.',
      searchPlaceholder: 'Search by name, email or WhatsApp',
      filters: {
        all: 'All',
        rented: 'We rented it',
        not_rented: "Didn't rent",
        completed: 'Acquisition'
      },
      statusDisplay: {
        completed: 'Acquisition',
        rented: 'We rented it',
        not_rented: "Didn't rent"
      },
      selectedOwnerTitle: 'Selected owner',
      selectedOwnerEmpty: 'You have not selected anyone yet.',
      clearSelection: 'Remove owner',
      emptyTitle: 'No matches found',
      emptyDescription: 'We could not find owners with those filters. Try adjusting the search or review the owner requests panel.',
      selectCta: 'Select',
      changeCta: 'Change owner',
      loading: 'Loading owners...',
      error: 'We could not load the owners list.',
      retry: 'Try again',
      contact: {
        whatsapp: 'WhatsApp',
        email: 'Email'
      },
      profileTitle: 'Owner',
      selectorTitle: 'Owners',
      selectorSubtitle: 'Filter and choose the right owner to link this property.',
      statusLabel: 'Status',
      updatedAt: 'Updated {{relative}}',
      readyBadge: 'Ready to publish'
    }
  },
  edit: {
    title: 'Edit Property',
    loading: 'Loading property...',
    errors: {
      titleAddressRequired: 'Title and address are required',
      mustUploadImage: 'You must upload at least one image',
      updateFailed: 'Failed to update property'
    },
    toasts: {
      successUpdateTitle: 'Success',
      successUpdateDesc: 'Property updated successfully'
    },
    nav: {
      applyChanges: 'Apply changes',
      savingChanges: 'Saving changes...'
    }
  },
  errors: {
    required: 'Required',
    numeric: 'Numeric',
    fetchSuggestions: 'Could not load suggestions',
    reverseGeocode: 'Could not fetch address',
  missingImages: 'You must add at least one image.',
  validationFailed: 'Validation failed',
  uploadFailed: 'Upload failed',
  unexpected: 'An unexpected error occurred'
  },
  location: {
    searchLabel: 'Address / Search',
    searchPlaceholder: 'Enter address, neighborhood, city...',
    searching: 'Searching...',
    mapLoading: 'Loading map (needs Google Maps)...',
    reverseFetching: 'Fetching address...',
    geocodeNote: 'Geocoding runs after typing pause',
    reverseButton: 'Reverse',
    title: 'Property Location',
    fullAddress: 'Full address',
    city: 'City',
    state: 'State',
    zip: 'Postal Code',
    coordinates: 'Coordinates',
    mapPreview: 'Map preview',
    addressHint: 'Type and select a suggestion to auto-save coordinates.',
    enterAddressMap: 'Enter an address to see it on the map',
    loadingMapNoGoogle: 'Loading map (Google Maps unavailable)...'
  },
  media: {
    title: 'Media',
    dragHere: 'Drag images here or',
    select: 'Select',
    upload: 'Upload',
    progress: 'Progress',
    none: 'No images added',
    uploading: 'Uploading',
    error: 'Error',
    featured: 'Featured',
    drag: 'Drag',
    retry: 'Retry',
    retrying: 'Retrying...',
    failedCount: 'failed',
    cancelUpload: 'Cancel upload',
    confirmCancelTitle: 'Cancel upload',
    confirmCancelDesc: 'Uploads are in progress. Cancel them?',
    confirm: 'Confirm',
  dismiss: 'Dismiss',
  propertyMediaTitle: 'Property Media',
  propertyImagesLabel: 'Property images',
  advancedOptimization: 'Advanced optimization (WebP)',
  threads: 'Threads',
  quality: 'Quality',
  averageSavings: 'Average savings',
  dropImagesHere: 'Drag & drop images here',
  clickToSelect: 'or click to select',
  selectImages: 'Select images',
  setAsFeatured: 'Set as featured',
  primary: 'Featured',
  image: 'Image',
  imagesListLabel: 'Property images (reorderable)',
  keyboardInstructions: 'To reorder: press Space to pick up an image, use arrow keys to move, then Space again to drop.',
  imageAlt: 'Image {{index}}',
  remove: 'Remove image',
  markFeatured: 'Mark as featured',
  retryOne: 'Retry upload',
  replace: 'Replace',
  removeImage: 'Remove image',
  dragToReorder: 'Drag to reorder'
  },
  video: {
    sectionTitle: 'Video, Plans & Links',
    videoUrlLabel: 'Video URL (YouTube)',
    videoUrlPlaceholder: 'Ex: https://www.youtube.com/watch?v=dQw4w9WgXcQ',
    virtualTour: 'Virtual tour (URL)',
    externalLink: 'External link',
    plans: 'Plans / PDFs',
    add: 'Add',
    newCount: 'new',
    noPlans: 'No plans added.',
    preview: 'Preview',
    video: 'Video',
    tour: 'Virtual tour',
    link: 'External link',
    plansShort: 'Plans',
    validating: 'Validating',
    valid: 'Valid',
    invalidUrlTitle: 'Invalid URL',
    invalidUrlDesc: 'The YouTube URL is not valid. Please check the format.',
    warningInvalidInline: 'URL seems invalid. Check the format.',
    thumbnailLabel: 'Video thumbnail image',
    selectImage: 'Select image',
    thumbnailHelp: 'You can pick a custom thumbnail image (recommended 1280x720px)',
    exampleValid: 'Example of valid format',
    openOnYoutube: 'Open on YouTube',
  clear: 'Clear',
  plansDropzoneLabel: 'Plans drop zone'
  },
  review: {
    title: { prefix: 'Review & Publish' },
    basicInfo: 'Basic Information',
    location: 'Location',
    media: 'Media',
    featuredImage: 'Featured image',
    mainImage: 'Main image',
    noExtraImages: 'No additional images',
    extraFeatures: 'Additional features'
  }
};

export const STRINGS = {
  es: ES_BASE,
  'es-MX': ES_BASE,
  en: EN_BASE,
  'en-US': EN_BASE
} as const;

export type Lang = keyof typeof STRINGS;
export const defaultLang: Lang = 'es';

export function t(path: string, lang: Lang = defaultLang, params?: Record<string,string|number>): string {
  const parts = path.split('.');
  let cur: any = STRINGS[lang] || STRINGS.es;
  for (const p of parts) {
    cur = cur?.[p];
    if (cur == null) return path; // fallback key
  }
  if (typeof cur !== 'string') return path;
  if (params) {
    return cur.replace(/{{(\w+)}}/g, (_, k) => params[k]?.toString() ?? '');
  }
  return cur;
}
